module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1",
    attrs: {
      "id": "pz7-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/contents#a2",
      "id": "b2"
    }
  }, [_vm._v("Chapter 1")])]), _vm._v(" "), _c('p', {
    staticClass: "h1a"
  }, [_c('a', {
    attrs: {
      "href": "#/contents#a3",
      "id": "b3"
    }
  }, [_vm._v("Sustaining a Small Business:")])]), _vm._v(" "), _c('p', {
    staticClass: "h1a"
  }, [_c('a', {
    attrs: {
      "href": "#/contents#a3"
    }
  }, [_vm._v("Getting Started What is Business Sustainability?")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz7-4"
    }
  }, [_vm._v("\n\t\t\t\t\tSustainability is a strategy that "), _c('span', {
    staticStyle: {
      "text-decoration": "underline"
    },
    attrs: {
      "id": "AP4d"
    }
  }, [_vm._v("drives long-term")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "text-decoration": "underline"
    },
    attrs: {
      "id": "ANoz"
    }
  }, [_vm._v("business growth and profitability")]), _vm._v(".\n\t\t\t\t\tKeeping a small business operating after the start-up phase is a major challenge\n\t\t\t\t\tfor small businesses across the country. According to CNN (May 20, 2011), across\n\t\t\t\t\tthe United States, small business failure rates rose by 40% between 2007 and 2010,\n\t\t\t\t\taccording to the report. Only two-thirds of new small businesses survive at least\n\t\t\t\t\ttwo years, and just 44 percent survive at least four years, according to a study\n\t\t\t\t\tby the U.S. Small Business Association. Even businesses with substantial start-up\n\t\t\t\t\tfunds flail around in a brutal economic climate. Those that survived either cut back\n\t\t\t\t\tseverely on expenditures or filed for bankruptcy court protection allowing them to\n\t\t\t\t\tpay off creditors over a longer period of time. Staying solvent means enduring or\n\t\t\t\t\tweathering bad times. Surviving all closure odds and trends means that the survivors\n\t\t\t\t\thad a sustainability plan. ")]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "pz8-1"
    }
  }, [_c('span', {
    staticStyle: {
      "text-decoration": "underline"
    },
    attrs: {
      "id": "AgIA"
    }
  }, [_c('b', [_vm._v("How can I adopt a sustainability mind-set?")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz8-2"
    }
  }, [_vm._v("\n\t\t\t\t\tStrategizing for sustainability involves understanding and adopting the following\n\t\t\t\t\t"), _c('i', [_vm._v("stay in business")]), _vm._v(" mind-set: ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "pz8-3"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.3em"
    }
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" "), _c('b', [_vm._v("Eliminating Visioning Barriers.")]), _vm._v(" Focus on being mentally prepared for staying in\n\t\t\t\t\tbusiness beyond the finish line. This means closing your ears to all naysayers who\n\t\t\t\t\tdidn’t believe that you could start a business early on and now are waiting to give\n\t\t\t\t\tyou bad advice about how to run your business and stay in business. ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "pz8-4"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "margin-right": "0.3em"
    }
  }, [_vm._v("2.")]), _vm._v(" Sharpening Your Vision.")]), _vm._v(" Hone your ability to visualize business success in order\n\t\t\t\t\tto produce more confident actions. Increased confidence about business sustainability\n\t\t\t\t\tbreeds success. This means letting go of everyone in your circle of colleagues and\n\t\t\t\t\tfriends that don’t share your vision. Controlling the environment that you manage\n\t\t\t\t\tand growing your business is critical to sustainability. ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "pz8-5"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "margin-right": "0.3em"
    }
  }, [_vm._v("3.")]), _vm._v(" Welcoming Sacrifice.")]), _vm._v(" Accept the fact that business success does not come without\n\t\t\t\t\tsacrifice of self, other human sources, and personal/business finances. This means\n\t\t\t\t\tadopting the “failure is not an option” mindset to achieve and sustain your dream\n\t\t\t\t\tof a successful business venture. ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "pz9-1"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "margin-right": "0.3em"
    }
  }, [_vm._v("4.")]), _vm._v(" Learning to Take Risks.")]), _vm._v(" Draw from the actions of earlier successful entrepreneurs\n\t\t\t\t\twho dynamited their way to the top of the Fortune 500 corporations list. Corporate\n\t\t\t\t\tvisionaries such as Bill Gates, Warren Buffet, and others realized early on that\n\t\t\t\t\tsuccess comes to those who recognize and take risks, are unafraid of risk, and are\n\t\t\t\t\twilling to execute based on their own ideas (driving visions). This means that if\n\t\t\t\t\tyou are a risk avoider, your chances of business survival (aka sustainability) will\n\t\t\t\t\tprobably be slim. ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "pz9-2"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "margin-right": "0.3em"
    }
  }, [_vm._v("5.")]), _vm._v(" Creating Something Out of Nothing.")]), _vm._v(" When clients and customers are few and far\n\t\t\t\t\tbetween, revenues are less or nonexistent. This means that you must be able to pattern\n\t\t\t\t\tyour actions like the actions of the business owners that have already achieved long-term\n\t\t\t\t\tbusiness sustainability. Think outside of the usual box for operating your business\n\t\t\t\t\tand create a plan for drumming up new revenues. ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "pz9-3"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "margin-right": "0.3em"
    }
  }, [_vm._v("6.")]), _vm._v(" Drawing Up a Sustainability Roadmap.")]), _vm._v(" Remember the questions that I asked you under\n\t\t\t\t\t"), _c('b', [_c('i', [_vm._v("How Can This Book Help Me?")])])]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    staticStyle: {
      "text-indent": "0.1em"
    }
  }, [_vm._v(" Carefully thinking about your responses and writing them\n\t\t\t\t\tdown constitutes your own customized sustainability plan. This means you must read\n\t\t\t\t\tthe rest of this book so you have a working desktop guide on how to achieve "), _c('span', {
    attrs: {
      "id": "z10-1"
    }
  }, [_vm._v("business\n\t\t\t\t\tsustainability, also known as how to beat the odds! ")])]), _vm._v(" "), _c('div', {
    staticClass: "box",
    attrs: {
      "id": "Aft"
    }
  }, [_c('p', {
    staticClass: "ser",
    attrs: {
      "id": "pAKx"
    }
  }, [_c('img', {
    staticStyle: {
      "float": "left",
      "margin-right": "1.5em"
    },
    attrs: {
      "alt": "images/img-10-1.jpg",
      "id": "AKx",
      "src": "images/img-10-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    staticStyle: {
      "text-indent": "0em",
      "margin-left": "3.8em",
      "margin-top": "-0.1em"
    },
    attrs: {
      "id": "pAsH"
    }
  }, [_c('b', [_c('i', [_vm._v("Rule of Thumb:")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    staticStyle: {
      "text-indent": "0em",
      "margin-left": "3.8em",
      "margin-top": "-0.1em"
    },
    attrs: {
      "id": "pATK"
    }
  }, [_vm._v("\n\t\t\t\t\t\tLook for like-minded entrepreneurs and owners of businesses that have lasted 10 years\n\t\t\t\t\t\tor more and are still successful. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz10-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#pz10-5"
    }
  }, [_c('b', [_vm._v("Table 1")])]), _vm._v(" shows you the possible outcomes if you adopt 100% of these new mindset recommendations:\n\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    staticStyle: {
      "margin-top": "1.2em"
    },
    attrs: {
      "id": "pz10-5"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "text-decoration": "underline"
    },
    attrs: {
      "id": "AgK"
    }
  }, [_vm._v("Table 1.1 - Overview "), _c('i', [_vm._v("of Staying Power")])])])]), _vm._v(" "), _c('table', {
    attrs: {
      "id": "Aid"
    }
  }, [_c('tbody', {
    attrs: {
      "id": "Azy"
    }
  }, [_c('tr', {
    attrs: {
      "id": "tr-Azy-0"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "center",
      "vertical-align": "top"
    },
    attrs: {
      "id": "td-Azy-0-0"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tMindset Shift To: ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center",
      "vertical-align": "top"
    },
    attrs: {
      "id": "td-Azy-0-1"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tAction Outcome ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center",
      "vertical-align": "top"
    },
    attrs: {
      "id": "td-Azy-0-2"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tNo Action Outcome ")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "id": "tr-Azy-1"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "td-Azy-1-0"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tEliminating Vision Barriers ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "td-Azy-1-1"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tGrowth & sustainability ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "td-Azy-1-2"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tEventual business failure ")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "id": "tr-Azy-2"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "td-Azy-2-0"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tSharpening Your Vision ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "td-Azy-2-1"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tGrowth & sustainability ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "td-Azy-2-2"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tBusiness suffocation leading to eventual failure ")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "id": "tr-Azy-3"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "td-Azy-3-0"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tWelcoming Sacrifice ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "td-Azy-3-1"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tGrowth & sustainability ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "td-Azy-3-2"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tAccepting failure and giving up on your dream(s) ")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "id": "tr-Azy-4"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "td-Azy-4-0"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tLearning to Take Risks ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "td-Azy-4-1"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tLearning from mistakes and experience growth and sustainability ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "td-Azy-4-2"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tPlaying it safe and eventually missing enough opportunities resulting in failure\n\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "id": "tr-Azy-5"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "td-Azy-5-0"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tCreating Something Out of Nothing ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "td-Azy-5-1"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tGrowth & sustainability ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "td-Azy-5-2"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tWaiting and waiting while the business is faltering into failure ")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "id": "tr-Azy-6"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "td-Azy-6-0"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tDrawing Up a Sustainability Road map ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "td-Azy-6-1"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tGrowth, sustainability & piece of mind ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "td-Azy-6-2"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tSaying you owned a short-term cyclical business that simply failed ")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "pz11-1"
    }
  }, [_c('span', {
    staticStyle: {
      "text-decoration": "underline"
    },
    attrs: {
      "id": "AkAp"
    }
  }, [_c('b', [_vm._v("Where do I go if I need help?")])])]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "pz11-2"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.8em"
    }
  }, [_vm._v("•")]), _vm._v(" ROTB (Rule of Thumb for Business) - Website: ("), _c('a', {
    attrs: {
      "href": "http://ruleofthumbbiz.com",
      "id": "AOL",
      "target": "_blank"
    }
  }, [_vm._v("ruleofthumbbiz.com")]), _vm._v(") ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "pz11-4"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.8em"
    }
  }, [_vm._v("•")]), _vm._v(" SBA Small Business ")]), _c('p', {
    staticClass: "pubo"
  }, [_vm._v("Development Centers – Website: ("), _c('a', {
    attrs: {
      "href": "http://www.sba.gov/about-offices-content/1/2894",
      "id": "Aoy8",
      "target": "_blank"
    }
  }, [_vm._v("http://www.sba.gov/about-offices-content/1/2894")]), _vm._v(")\n\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "pz11-7"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.8em"
    }
  }, [_vm._v("•")]), _vm._v(" University Schools/College of Business (faculty and student interns) ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "pz11-9"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.8em"
    }
  }, [_vm._v("•")]), _vm._v(" SCORE (Service Corps of Retired Executives) ")]), _vm._v(" "), _c('div', {
    staticClass: "box",
    attrs: {
      "id": "AbT"
    }
  }, [_c('div', {
    staticClass: "ser",
    attrs: {
      "id": "pA-d"
    }
  }, [_c('img', {
    staticStyle: {
      "float": "left",
      "margin-right": "1.5em"
    },
    attrs: {
      "alt": "images/img-11-1.jpg",
      "id": "A-d",
      "src": "images/img-11-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    staticStyle: {
      "text-indent": "0em",
      "margin-left": "3.8em",
      "margin-top": "-0.1em"
    },
    attrs: {
      "id": "pA2d"
    }
  }, [_c('b', [_c('i', [_vm._v("Rule of Thumb:")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    staticStyle: {
      "text-indent": "0em",
      "margin-left": "3.8em",
      "margin-top": "-0.1em"
    },
    attrs: {
      "id": "pAIT"
    }
  }, [_vm._v("\n\t\t\t\t\t\tRemember, this book is your desktop guide to small business sustainability; you will\n\t\t\t\t\t\tstill need to surround yourself with business sustainability experts. ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-baaaf0e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter01.vue
// module id = 69
// module chunks = 0